<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container">
    <a href="/#/principal" class="navbar-brand"><img src="assets/images/lhb.png" alt="homepage" class="light-logo" />
      <img src="assets/images/lhtextow.png" class="light-logo" alt="homepage" /></a>


    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">

        <ul class="navbar-nav ml-auto">

            <li class="nav-item">
                <a class="nav-link" href="/#/registro">Registrarse</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="/#/principal">Inicio</a>
          </li>

            <li class="nav-item">
              <a class="nav-link" href="/#/enviarmensaje">Contáctanos</a>
          </li>

        </ul>
    </div>
</div>
</nav>

<body>


  <div class="login-box card  mt-2">
    <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
    <div class="card-body">
        <form  [formGroup]="formularioLogin" class="form-material" (ngSubmit)="ingresar()">
          <h2 class="box-title text-center db"><b>¡Inicia sesión ahora!</b></h2>
            <div class="text-center db"><img src="assets/images/lh.png" alt="Home" /><br/>
              <img src="assets/images/lhtextob.png" alt="homepage" class="dark-logo" style="margin-top: 10px;"/></div>

            <div class="form-group mt-3">
              <label for="correo">Nombre de usuario (Correo Electrónico)</label>
              <div class="input-group">
                <div class="input-group-addon"></div>
                <input formControlName="correo" class="form-control input-sm" type="email" required email minlength="5" maxlength="150"><span class="bar"></span>
              </div>
              <div class="alert-danger" *ngIf="correo.invalid && (correo.dirty || correo.touched)" >
                <div class="container-error-message" *ngIf="correo.errors.required" >
                  El correo es requerido
                </div>
                <div class="container-error-message" *ngIf="correo.errors.minlength">
                  El correo debe tener mínimo 5 caracteres
                </div>
                <div class="container-error-message" *ngIf="(correo.dirty || correo.touched) && correo.invalid && correo.errors.pattern">
                  Debe ser un correo válido
                </div>
                <div class="container-error-message" *ngIf="correo.errors.maxlength">
                  El correo debe tener máximo 30 caracteres
                </div>
              </div>
            </div>


            <div class="form-group">
              <label for="password">Contraseña</label>
              <div class="input-group">
                <div class="input-group-addon"></div>
                <input formControlName="password" class="form-control" type="password" appVerPassword required minlength="6" maxlength="18"><span class="bar"></span>
              </div>
              <div class="alert-danger" *ngIf="password.invalid && (password.dirty || password.touched)" >
                <div class="container-error-message" *ngIf="password.errors.required" >
                  El password es requerido
                </div>
                <div class="container-error-message" *ngIf="password.errors.minlength" >
                  El password debe tener mínimo 6 caracteres
                </div>
                <div class="container-error-message" *ngIf="password.errors.maxlength">
                  El password debe tener máximo 18 caracteres
                </div>
              </div>
            </div>


            <div class="form-group row">
                <div class="col-md-12">
                  <a routerLink="/reseteopassword" id="to-recover" class="text-dark pull-right"><i class="fa fa-lock m-r-5"></i> ¿Olvidaste tu contraseña?</a>
                </div>
            </div>
            <div class="form-group text-center m-t-20">
                <div class="col-xs-12">
                    <button class="btn btn-info btn-lg btn-block text-uppercase btn-rounded" type="submit" [disabled]="!formularioLogin.valid">Iniciar Sesión</button>
                </div>
            </div>

            <div class="form-group m-b-0">
              <div class="col-sm-12 text-center">
                <p>
                  ¿No tienes cuenta?
                </p>
                <a routerLink="/registro" class="text-info m-l-5"><b>Regístrate</b></a>
              </div>
            </div>
        </form>
      </div>
    </div>
    <br>
    <br>
</body>


<div class="footer-dark">
  <footer>
      <div class="container">
          <div class="row">
              <div class="col-md-5 item">
                  <h3>Enlaces útiles</h3>
                  <ul>
                    <li><a href="/#/registro">Regístrate</a></li>
                    <li><a href="/#/enviarmensaje">Contáctanos</a></li>
                    <li><a href="/#/principal">Inicio</a></li>
                  </ul>
              </div>
              <div class="col-md-5 item">
                  <h3>Contacto</h3>
                  <ul>
                      <li><a href="#">Loja, Loja-Ecuador</a></li>
                      <li><a href="/#/enviarmensaje">Contáctanos</a></li>
                      <li><a href="#">0989994545</a></li>
                  </ul>
              </div>

              <div class="col item social"><a href="#"><i class="fa fa-facebook"></i></a>
                                           <a href="#"><i class="fa fa-youtube"></i></a>
                                           <a href="#"><i class="fa fa-instagram"></i></a>
                                           <a href="#"><i class="fa fa-google"></i></a></div>
          </div>
          <br>
          <p class="copyright">lojahouse.com © 2020</p>
      </div>
  </footer>
</div>
